import { Component,Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Api } from '../../Model/api-model';
import {RestApiService} from '../../Services/rest-api-service';
import { AppListResponse } from 'src/app/Model/apilistresponse-model';
import {createapp,createappResponse} from '../../Model/createappRequest-model';
import {Message,MessageService, SelectItem} from 'primeng/api';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import { App, SmartApp } from 'src/app/Model/app-model';
import { ProductList } from 'src/app/Model/productList-model';
import { ViewAppComponent } from './app.viewapp';
import { ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { environment } from 'src/environments/environment';
import { FormGroup, NgForm } from '@angular/forms';


@Component({
  selector: 'app-myapp',
  templateUrl: './app.myapp.html',
  providers:[MessageService]
})
export class MyAppComponent {

  displayedColumns: string[] = ['appName', 'roleLabel','callBackURL', 'clientId', 'Subscription','Update App','API Products'];
 

  //@ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  
  region=environment.getEnvironment();
  newapp =new createapp(); 
  isShown: boolean = false ;
  msgs: Message[]=[];
  deleteMsgs: Message[]=[];
  applistMsg:Message[]=[];
  updateMsgApp:Message[]=[];
  @Input() appName:string;
  @Input() callBackUrl:string;
  @ViewChild('newappform') form:NgForm;

  chplePdNum;
  chplePdName;
  jwksUrl;
  kid;

  path: SelectItem[];
  rolesOfDev: SelectItem[];
   pathValue:string;
   roleValue:string;
  //appname:string;
  //appcallbackUrl:string;

  createappResponsedata:createappResponse;
  statusMessage:string;
  appname_response:string;
  showSpinner:boolean;
  errorToastmessage:string;
  position: string;
  generalMessage:string;
  clientIDOnly:string;
  secretMsg:string;


  selecetedApp:App;
  loadAppRequest:boolean=false;
  editAppRender:boolean=false;   
  apis:Api[];
  colsForApiList: any[];
  appList:AppListResponse=new AppListResponse();
  appListLocal:AppListResponse=new AppListResponse();
  dataSource ;
  viewAppRender:boolean=false;   
  updateAppRender:boolean=false;   
  cols: any[];
  appListCols:any[];
  publicProductList:ProductList;
  @ViewChild('submit') submit:ElementRef;
  @ViewChild('subChild') subChild:ViewAppComponent;
  
  showClientID:boolean;


  disableAppCreation:boolean=true;

  activeInexApp=0;

  constructor(private router: Router,private restApi: RestApiService,private messageService:MessageService) {

    localStorage.setItem("is_cuurent_nav_aem","n");


    this.path = [
      {label:'Please Select an Option', value:null},
      {label:'Sandbox', value:'sandbox'},
      {label:'Production', value:'production'}
  ];


 /*  this.rolesOfDev = [
    {label:'Please Select an Option', value:null},
    {label:'An application to utilize patient access and/or provider directory APIs', value:'0'},
    {label:'A health plan to utilize payer to payer data exchange', value:'1'}
]; */
    this.rolesOfDev = [
      {label:'Please Select an Option', value:null},
      {label:'Third Party Application', value:'0'},
      {label:'Payer Application', value:'1'},
      {label:'Broker Application', value:'2'},
      {label:'EHR Application', value:'3'}
    ];


  }


changeEnvForPayer(){

    this.path = [
      {label:'Please Select an Option', value:null},
      {label:'Sandbox', value:'sandbox'},
      {label:'Production', value:'production'}
  ];

          this.pathValue=null;
         console.log("this"+this.roleValue)
        if(this.roleValue=='2'){

          this.path = [
            {label:'Please Select an Option', value:null},
            {label:'Production', value:'production'}
        ];
        //this.pathValue='production';
        }


        if(this.roleValue=='3'){

          this.path = [
            {label:'Please Select an Option', value:null},
            {label:'Sandbox', value:'sandbox'},
            {label:'Production', value:'production'}
        ];
        //this.pathValue='production';
        }



  }
 




      showClientIDM(app:App){
        app.render=true;
       // this.showClientID=true;
      }

      hideClientIDM(app:App){
        app.render=false;
       // this.showClientID=true;
      }


      showNoSubData=false;
      showGrid=false;
 
 
 loadAppInfoOnNgOnInit(){

  this.activeInexApp=0;
  this.showNoSubData=true;
  this.showGrid=true; 
      this.messageService.clear('createappKey');
      this.messageService.clear('updateappKeyApp');
      this.loadAppRequest=true; 

      this.cols = [
            { field: 'name', header: 'API Names' }];

            
        //this.colsForApiList=  [   { field: 'name', header: 'Name' },{ field: 'url', header: 'CallBack URL' },{ field: 'ClientID', header: 'ClientID' },{ field: 'view', header: 'View' },{ field: 'delete', header: 'Delete' },{ field: 'update', header: 'Update' }];
      this.apis=[{name:'FHIR Api One',version:'1',status:'Approved',cssname:'qualified',appname:'Sample App One',ischecked:false},{name:'FHIR Api Two',version:'1',status:'Approved',cssname:'qualified',appname:'Sample App Two',ischecked:false},{name:'FHIR Api Three',version:'1',status:'Pending',cssname:'proposal',appname:'Sample App Three',ischecked:false},{name:'FHIR Api Four',version:'1',status:'Rejected',cssname:'unqualified',appname:'Sample App Four',ischecked:false}];
     
     
   let isFirst=localStorage.getItem("is_first_load");
     
     if(isFirst=="yes"){

      localStorage.setItem("is_first_load","NO");

      this.loadAppList();
     }else{
     
       if(localStorage.getItem("my_smart_App")){
          let myAPP=localStorage.getItem("my_smart_App");
        
         // console.log("parsing json "+myAPP)
          this.appList.appListView= JSON.parse(myAPP) as App[];

         
          this.dataSource = new MatTableDataSource<App>(this.appList.appListView.reverse());
          this.dataSource.paginator = this.paginator;
    
          if(this.appList.appListView.length!=0){this.showGrid=false;}else{this.showNoSubData=false;}
    



         }
        
         this.loadAppRequest=false;  
     }
     
     
      //create app
        this.showSpinner =false;
        
        this.appListCols = [
          { field: 'appName', header: 'Application Name' },
          { field: 'callBackURL', header: 'Callback URL' },
          { field: 'clientId', header: 'Client ID' }
          
      ];



 }
 
       createAppOnNgOnInit(){


        this.activeInexApp=1;


          let myRole=   localStorage.getItem("direct_app_role");
          let myenv=   localStorage.getItem("direct_app_environment");

        
          if(myRole=='development'){
            myRole="0"
           }else if(myRole=='payer'){
 
             myRole="1";
           }
           else if(myRole=='provider'){
 
            myRole="3";
          }else{
             myRole="2";
           }


          console.log("my role is "+myRole)
          this.pathValue=myenv;
          this.roleValue=myRole;

          this.checkApprovalStatus();


 
       }
 
 
 
 
 
      ngOnInit() {
        

        let directApp= localStorage.getItem("direct_app");

        if(directApp=="Y"){

          this.createAppOnNgOnInit();
        }else{

         this.loadAppInfoOnNgOnInit();
        }

        localStorage.setItem("direct_app","N");

      }
      ngAfterViewInit(): void{
      //  this.dataSource.paginator = this.paginator;
  
      window.scroll(0,0);

  
  
  
      if (localStorage.getItem("appName") && localStorage.getItem("deleteappcounter")==="1") {
        const appname_local=localStorage.getItem("appName");
        localStorage.setItem("deleteappcounter","2");
        localStorage.removeItem("appname");
        localStorage.removeItem("Flag");
        this.messageService.add({key:"appListKey",severity:'info',detail:'App '+appname_local +" successfully deleted."});
       // window.alert(appname)   
    }
    else{
      localStorage.removeItem("appname");
      localStorage.removeItem("Flag");
      localStorage.removeItem("deleteappcounter")
      this.messageService.clear('appListKey');
    }
      
    }



  showAppView(app:App){
    this.selecetedApp=app;
    this.viewAppRender=true;
    this.updateAppRender=false;
    this.editAppRender=false;
    this.messageService.clear('createappKey');
    this.messageService.clear('appListKey');
    this.messageService.clear('updateappKeyApp');
    localStorage.setItem("path",app.path);
    this.subChild.viewStartUp(app.appID,app.appName,app.callBackURL,app.path);
  }

  updateApp(app:App){
    this.selecetedApp=app;
    this.messageService.clear('updateappKeyApp');
    localStorage.setItem("path",app.path);

      if(app.legacyInd){

          if(app.legacyInd=='apigee'){
            localStorage.setItem("appSys","apigee");
          }else{
            localStorage.setItem("appSys","apic");
          }

      }

    this.viewAppRender=false;
    this.updateAppRender=true;
    this.editAppRender=false;
    this.messageService.clear('createappKey');
    this.messageService.clear('appListKey');
  }



accessErrorMsg;

  productSelectionUsingRole(app:App){

     let env=app.path;
     let role=app.roleValue;

     let envDisplay;
     let roleDisplay;

     if(env=='sandbox'){
      envDisplay='Sandbox';

     }else{
      envDisplay='Production';
     }

     if(role=='1'){
      roleDisplay='Payer';
     }else if(role=='0'){
      roleDisplay='Third Party App';
      
     }

     else if(role=='3'){
      roleDisplay='Provider';
      
     }
     else{
      roleDisplay='Broker';
     }

    this.accessErrorMsg="Please create an application from \"My Applications\" tab as "+roleDisplay+" in "+ envDisplay+" environment for subscription approval request.";


    let finalAccessValue;

    if(env=='sandbox' && role=='0'){

      finalAccessValue=localStorage.getItem("my_new_vet_sd")
      
    }
    if(env=='sandbox' && role=='1'){
              
      
      finalAccessValue=localStorage.getItem("my_new_vet_sp");
    
    }

    if(env=='sandbox' && role=='2'){
              
      
      finalAccessValue=localStorage.getItem("my_new_vet_sb");
    
    }

    if(env=='sandbox' && role=='3'){
              
      
      finalAccessValue=localStorage.getItem("my_new_vet_spd");
    
    }




    if(env=='production' && role=='0'){
    
      finalAccessValue= localStorage.getItem("my_new_vet_pd");
    
    }
    if(env=='production' && role=='1'){
            
    
      finalAccessValue=localStorage.getItem("my_new_vet_pp");
    }


    if(env=='production' && role=='2'){
            
    
      finalAccessValue=localStorage.getItem("my_new_vet_pb");
    }

   

    if(env=='production' && role=='3'){
            
    
      finalAccessValue=localStorage.getItem("my_new_vet_ppd");
    }


     if(finalAccessValue=='P' || finalAccessValue=='N'){
     
        this.accessDenyError=true;
         return true;
    }








    localStorage.setItem("app_id_nv",app.appID);

    if(app.roleValue=='1'){

      console.log("inside payer products")
      localStorage.setItem("roleValue","1");
      this.editApp(app);

    }else if(app.roleValue=='0'){
      
      localStorage.setItem("roleValue","0");
      this.editApp(app);
    }
    else if(app.roleValue=='3'){
      
      localStorage.setItem("roleValue","3");
      this.editApp(app);
    }

    else{

      localStorage.setItem("roleValue","2");
      this.editApp(app);
    }



    }





    editApp(app:App){
         this.selecetedApp=app;
         localStorage.setItem("path",app.path);
         this.viewAppRender=false;
          this.updateAppRender=false;
          this.editAppRender=true;
          this.messageService.clear('createappKey');
          this.messageService.clear('appListKey');
          this.messageService.clear('updateappKeyApp');
         this.goToProducats();

      }
    

      async loadSmartAppFlag(smartApp:App){



         let smartAppId=smartApp.appID;

         if(smartApp.legacyInd=='y'){

          smartAppId=smartApp.v5Id;
         }


        

          return this.restApi.getSmartAppFlag(smartAppId).subscribe((data: {}) => {
 
      //console.log("samrt app "+data.payerFlag)
      

        let  ResponseApp= data as SmartApp;

         smartApp.roleValue= ResponseApp.payerFlag;

         if(smartApp.roleValue=='1'){
          smartApp.roleLabel='Payer Application';
          smartApp.roleValue='1';
         }else if(smartApp.roleValue=='0' || smartApp.roleValue==""){
           smartApp.roleLabel='Third Party Application';
           smartApp.roleValue='0';
         }
         else if(smartApp.roleValue=='3'){
          smartApp.roleLabel='EHR Application';
          smartApp.roleValue='3';
        }

         else{
           smartApp.roleLabel='Broker Application';
           smartApp.roleValue='2';
         }


        

       smartApp.displayLine=true;

      
      // console.log("smart app "+smartApp)
       this.appListLocal.appListView.push(smartApp);
      // console.log("smart app local array "+this.appListLocal.appListView)
       
      
       localStorage.setItem("my_smart_App",JSON.stringify(this.appListLocal.appListView));      

    },(error)=>{

      
      if(smartApp.legacyInd=='apigee'){

          smartApp.roleLabel='EHR Application';
          smartApp.roleValue='3';
       }
       else{
        smartApp.roleLabel='Third Party Application';
        smartApp.roleValue='0';
       }
      
      smartApp.displayLine=true;
         
      localStorage.setItem("my_smart_App",JSON.stringify(this.appListLocal.appListView));      

    })

}

isEHRProd=false;

  checkApprovalStatus(){

    //console.log("check approval status ");
this.isEHRProd=false;
    localStorage.setItem("Lower_value_approval",'NA');

    this.disableAppCreation=true;
    let env=this.pathValue;

    let role=this.roleValue;

    console.log("check approval status env "+env);

    console.log("check approval status "+role);

    localStorage.setItem('roleValue',role);

    localStorage.setItem('access_env',env);

    // changes for broker role
    let sd,sp,pd,pp,sb,pb,spd,ppd;

    let finalAccessValue;
    let lowerApprovalValue;

    localStorage.setItem("new_vettting_behaviour","NA");

                  if(env=='sandbox' && role=='0'){


                    let upperValue= localStorage.getItem("my_new_vet_pd");
                    finalAccessValue=localStorage.getItem("my_new_vet_sd");

                  

                      if(finalAccessValue=='P' && upperValue=='A'){
                        finalAccessValue='N';
                      }
                    
                  }
                  if(env=='sandbox' && role=='1'){
                            
                        let  upperValue  =localStorage.getItem("my_new_vet_pp");
                    
                        finalAccessValue=localStorage.getItem("my_new_vet_sp");

                        if(finalAccessValue=='P' && upperValue=='A'){
                          finalAccessValue='N';
                        }

                  
                  }

                   // changes for broker role
                   if(env=='sandbox' && role=='2'){
                            
                    let  upperValue  =localStorage.getItem("my_new_vet_pb");
                
                    finalAccessValue=localStorage.getItem("my_new_vet_sb");

                    if(finalAccessValue=='P' && upperValue=='A'){
                      finalAccessValue='N';
                    }

              
                }


                 // changes for provider role
                 if(env=='sandbox' && role=='3'){
                            
                  this.isEHRProd=true; 
                   
                  let  upperValue  =localStorage.getItem("my_new_vet_ppd");
              
                  finalAccessValue=localStorage.getItem("my_new_vet_spd");

                  if(finalAccessValue=='P' && upperValue=='A'){
                    finalAccessValue='N';
                  }

            
              }



                  if(env=='production' && role=='0'){
                  
                    finalAccessValue= localStorage.getItem("my_new_vet_pd");
                    lowerApprovalValue=localStorage.getItem("my_new_vet_sd");

                    if(lowerApprovalValue=='A'){
                      //localStorage.setItem("single_email","1")
                      localStorage.setItem("new_vettting_behaviour","Y");
                    }
                  
                  }
                  if(env=='production' && role=='1'){
                          
                  
                    finalAccessValue=localStorage.getItem("my_new_vet_pp");
                    lowerApprovalValue=localStorage.getItem("my_new_vet_sp");

                    if(lowerApprovalValue=='A'){
                      //localStorage.setItem("single_email","1")
                      localStorage.setItem("new_vettting_behaviour","Y");
                    }
                  }


                 // changes for broker role


                 if(env=='production' && role=='2'){
                          
                  
                  finalAccessValue=localStorage.getItem("my_new_vet_pb");
                  lowerApprovalValue=localStorage.getItem("my_new_vet_sb");

                  if(lowerApprovalValue=='A'){
                    //localStorage.setItem("single_email","1")
                    localStorage.setItem("new_vettting_behaviour","Y");
                  }
                }



                  // changes for provider role


                  if(env=='production' && role=='3'){
                                            
                    this.isEHRProd=true; 
                    finalAccessValue=localStorage.getItem("my_new_vet_ppd");
                    lowerApprovalValue=localStorage.getItem("my_new_vet_spd");

                    if(lowerApprovalValue=='A'){
                      //localStorage.setItem("single_email","1")
                      localStorage.setItem("new_vettting_behaviour","Y");
                    }
                  }


                   
                  localStorage.setItem("Lower_value_approval",lowerApprovalValue);


                   if(finalAccessValue=='A'){
                      console.log('Good to go '+finalAccessValue);
                      this.disableAppCreation=false;
                   }

                   if(finalAccessValue=='P'){
                    console.log('Alreday Raised '+finalAccessValue);
                   
                    this.router.navigate(['raise-request/already-raised']);


                  }

                  if(finalAccessValue=='N'){
                     
                    console.log('Please rasie the request '+finalAccessValue);

                    this.router.navigate(['raise-request/new']);
                  }

  }



  loadAppList() {
    localStorage.removeItem("my_smart_App"); 
    this.appListLocal.appListView=[];
    return this.restApi.getAppList().subscribe(async (data: {}) => {
      this.showGrid=true;
      this.showNoSubData=true;
      //this.appList = data;
     // console.log("App List"+data); 
      this.appList=data as AppListResponse;
     // console.log("App List"+this.appList.status); 

      for(let myapp of this.appList.appListView){

        console.log("my app id "+myapp.appID)
        await this.loadSmartAppFlag(myapp);
        
      }

 
      
     this.loadAppRequest=false;   
      this.dataSource = new MatTableDataSource<App>(this.appList.appListView.reverse());
      this.dataSource.paginator = this.paginator;

      if(this.appList.appListView.length!=0){
        this.showGrid=false;
      }else{
        this.showNoSubData=false;

      }

    },(error)=>{this.loadAppRequest=false; 
     // console.log("error handling in component"+this.loadAppRequest);
    })
  }

  loadAppListOnClick(){
   this.loadAppRequest=true;
   this.messageService.clear('updateappKeyApp');
   // console.log("refrsh on click");
   this.loadAppList();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onSelect(e){
   // console.log("clear messages");
   this.form.reset();
   this.updateAppRender=false;
    this.messageService.clear('createappKey');
    this.messageService.clear('appListKey');
    this.messageService.clear('updateappKeyApp');

    this.disableAppCreation=true;
  }
accessDenyError=false;
appCreationDisabled=false;
// Create newapp confimation service call. once confirm it it will call service call and back responce otherwise shows error 
createnewApp(){
 
 // console.log("Appname and callbackUrl"+this.appName + this.callBackUrl);
 
   if (this.form.invalid) {
      // Form is valid, proceed with submission logic
      console.log('Form submitted is not valid');
      this.form.control.markAllAsTouched();
       return true;
  
    } 


 
 if(this.roleValue=='3' && this.pathValue=='production'){
 
          this.appName=this.appName.split(' ').join('');

          let tempApp=this.appName;

          let size=tempApp.length;
   
         
          let check=this.onlyLettersAndNumbers(tempApp);
          //window.alert("size:check "+size+check)
              if(size<5 || size>30 || (!check)){
              
                window.alert("The Application Name should have a minimum of 5 characters and a maximum of 30 characters. No special characters allowed, and spaces will be removed from the Application Name.");
                return true;
              }// end of minimum, maximum and characters and special characters check

              this.kid=this.kid.split(' ').join('');

              let tempKid=this.kid;
    
              let sizeKid=tempKid.length;
       
             
              let checkKid=this.onlyLettersAndNumbersandHypen(tempKid);
              //window.alert("size:check "+size+check)
                  if(sizeKid<5 || sizeKid>50 || (!checkKid)){
                  
                    window.alert("The KID should have a minimum of 5 characters and a maximum of 30 characters. No special characters are allowed except '-', and spaces will be removed from the KID.");
                    return true;
                  }// end of minimum, maximum and characters and special characters check
       
            
           

         

  }// end of if, app rules for EHR app

  this.loadAppRequest =true;

 let validURL=this.callBackUrl.toLowerCase();

 if(validURL.startsWith("http://") || validURL.startsWith("https://")){

 }else{

   this.showSpinner=false;
   this.loadAppRequest =false;

   this.messageService.clear('createappKey');
   
   this.messageService.add({key: 'createappKey',severity:'error',detail:"Invalid Callback URL. Please note the Callback URL should start with http:// or https://"});


   return true;
 }



 
    var pageElement = document.getElementById("myappviewscroll");
    pageElement.scrollIntoView(true);






  if(this.appName !== null && this.appName !=="" && this.callBackUrl!=="" && this.callBackUrl!==null ){
  this.showSpinner =true;
  localStorage.setItem("path",this.pathValue);
 
  const  payerFlag=parseInt(this.roleValue);

  const requestJSON={"appName":this.appName,"callBackUrl":this.callBackUrl,'emailID':"",'role':payerFlag,"jwksUri":this.jwksUrl,"certifiedProductId":this.chplePdNum,"certifiedProductName":this.chplePdName,"kid": this.kid};
    //console.log(requestJSON);
   
    this.appCreationDisabled=true;
   
    this.restApi.createApp_PostRequest(requestJSON).subscribe(
      (data:createappResponse) =>
        
      { 
      //  console.log(data);
        this.createappResponsedata=data;
       // console.log(this.createappResponsedata.callBackUrl);
        //this.toastcreateappMessage="•	Please save the Secret for this App,client secret will not get displayed again for this App.App Name ";
        this.appname_response=this.createappResponsedata.appName;
       // console.log("appname "+this.createappResponsedata.appName);
       // console.log("appid "+this.createappResponsedata.appID);
       // console.log("client id "+this.createappResponsedata.clientId);
      // this.appName="";
        let regionInput="QA";
       // console.log("region "+this.region)
          if(this.region=="prod"){
            if(this.pathValue=="production"){
              regionInput="Production";
            }else{
              regionInput="VTE";
            }
           
          }

        this.createnSmartApp(this.createappResponsedata.appName,this.createappResponsedata.clientId,this.createappResponsedata.appID,regionInput);

       // this.clientInfo="\n clientid"+":"+this.createappResponsedata.clientId+"\n"+"clientSecrete"+":"+this.createappResponsedata.clientSecret;
        this.statusMessage=this.createappResponsedata.status;

        this.appCreationDisabled=false;
        if (this.statusMessage ==="Success"){
          this.showSpinner =false;
          this.loadAppRequest =false;
         // (<HTMLInputElement>document.getElementById("appName")).value=null;
         // (<HTMLInputElement>document.getElementById("callbackUrl")).value=null;
          //this.submit.nativeElement.disabled = true;
        //  this.form.reset();

        this.appName="";
        this.callBackUrl="";
        this.jwksUrl="";
        this.chplePdNum="";
        this.chplePdName="";
        this.kid="";
        this.form.control.markAsUntouched();
          this.messageService.clear('createappKey');
          //this.isShown=!this.isShown;
          this.messageService.add({key: 'createappKey',severity:'info',detail: "Please save the client secret for this App, client secret will not get displayed again for this App."});
          this.messageService.add({key: 'createappKey',severity:'info',detail: "App Name :"+this.appname_response});
          this.messageService.add({key: 'createappKey',severity:'info',detail: "Client ID : "+this.createappResponsedata.clientId});
          this.messageService.add({key: 'createappKey',severity:'info',detail: "Secret : "+this.createappResponsedata.clientSecret});
          
      }
      else{
            this.showSpinner=false;
            this.loadAppRequest =false;
         
            this.messageService.clear('createappKey');
           // const obje_Json=JSON.parse(this.createappResponsedata.errorMessage);
            //var s=Object.values(obje_Json.errors[0]);
            //this.errorToastmessage = s.toString();
            //const Error_string=obje_Json.errors[0]["apps.name.conflict"];
            //this.errorToastmessage = Error_string.toString();
            //this.isShown=!this.isShown;
            //this.messageService.add({key: 'createappKey',severity:'error',detail:this.errorToastmessage});
            this.messageService.add({key: 'createappKey',severity:'error',detail:this.createappResponsedata.errorMessage});
     
      }
    
    },
      (error) =>{
        this.appCreationDisabled=false;
        this.showSpinner=false;
        this.messageService.clear('createappKey');
        //this.isShown=!this.isShown;
        this.messageService.add({key: 'createappKey',severity:"error",detail:this.statusMessage});
      }
      
      
    )
  }
  else{
    this.appCreationDisabled=false;
    this.loadAppRequest=false;
    this.showSpinner=false;
    this.messageService.clear('createappKey');
    this.submit.nativeElement.disabled = true;
    //this.isShown=!this.isShown;
    this.messageService.add({key:'createappKey',severity:'error', summary:'Callback URL and Appname is required.', detail:''});

  }

}

 onlyLettersAndNumbers(str) {
	return /^[A-Za-z0-9]*$/.test(str);
}
onlyLettersAndNumbersandHypen(str) {
	return /^[A-Za-z0-9-]*$/.test(str);
}


handleData(data: any) {
  //this.receivedData = data.message;
//console.log("we are here")
this.selecetedApp.callBackURL=data.callBackUrl;
this.selecetedApp.chplId=data.chplProductId;
this.selecetedApp.chplProductName=data.chplProductName;
this.selecetedApp.kid=data.kid;
this.selecetedApp.jwksUrl=data.jwksURL;

          var pageElement = document.getElementById("myappviewscroll");
          pageElement.scrollIntoView(true);

this.messageService.add({key:'updateappKeyApp',severity:'info', detail:'App Name : '+ this.selecetedApp.appName +"  successfully updated."});

}

/*
clear(){
  this.messageService.clear();
  this.msgs = []; 
  this.isShown=!this.isShown;
  //this.HideMessageid.nativeElement.Hide=true;
  //this.Messageid.nativeElement.Hide= true;   
}*/
  /*createnewApp(){
    this.loadAppRequest =true;
       this.newapp ={...this.newapp, ...{'emailID':""}};
      // console.log(this.newapp);
      this.restApi.createApp_PostRequest(this.newapp).subscribe(
        (data:createappResponse) =>
          
        { 
          console.log(data);
          this.createappResponsedata=data;
          
          this.toastcreateappMessage=this.createappResponsedata.appName +"creation";
          this.clientInfo="clientid"+":"+this.createappResponsedata.clientId+","+"clientSecrete"+":"+this.createappResponsedata.clientSecret;
          
         // console.log(this.createappResponsedata.errorMessage["errors"].apps.name.conflict);
          this.statusMessage=this.createappResponsedata.status;
       if (this.statusMessage ==="Success"){
            this.loadAppRequest =false,
       
            this.messageService.add({severity:'info',detail:"Please save the Secret for this App,client secret will not get displayed again for this App.App Name "+this.createappResponsedata.appName});
            this.messageService.add({severity:'info',detail:"Client ID : "+this.createappResponsedata.clientId});
            this.messageService.add({severity:'info',detail:"Secret : "+this.createappResponsedata.clientSecret});
  
        }
        else{
          this.loadAppRequest=false,
          
        this.messageService.add({severity:'error',detail:this.toastcreateappMessage+":"+ this.statusMessage+
        "Client info"+":"+this.clientInfo})
        }
       
        
       // this.showSpinner =false,
       
       // this.messageService.add({severity:'info',detail:'Successfuly added'})
       
        
      },
        (error) =>{this.loadAppRequest=false,
          
        this.messageService.add({severity:'error',detail:'Error occured'})
          
      }
        
        
      )

  }*/


  createnSmartApp(appName:string,clientID:string,appId:string,region:string){
     
    localStorage.setItem("smart_app","yes");
  const  payerFlag=parseInt(this.roleValue);
    const requestJSON={"smartApplicationId":appId,"smartApplicationName":appName,"envName":region,"clientId":clientID,"payerFlag": payerFlag};
       //console.log(requestJSON);
        this.restApi.smartApp_PostRequest(requestJSON).subscribe(
         (data) =>
           
         { 
           console.log(data);
           localStorage.removeItem("smart_app");     
       },
         (error) =>{
         
          localStorage.removeItem("smart_app");
          console.log(error);

          // this.showSpinner=false;
          // this.messageService.clear('createappKey');
           //this.isShown=!this.isShown;
         //  this.messageService.add({key: 'createappKey',severity:"error",detail:this.statusMessage});
         }
         
         
       )
     }

     ngAfterViewChecked(){
      document.querySelectorAll('table')
      .forEach((input) => {
       // console.log(input.getAttribute("role"));
         if(input.getAttribute("role")=="grid"){
          input.removeAttribute("role");
         }
       
      });

    }


    goToProducats(){


   
      let top = document.getElementById('productsscrollmyapp');
      if (top !== null) {
        top.scrollIntoView();
        top = null;
      }
    
    }



   }




